import { useState } from 'react';

import { AttachmentStoreContext } from './attachment-store-context.js';
import { createAttachmentStore } from './attachment-store.js';

import type { ReactNode } from 'react';

export function AttachmentStoreProvider({ children }: { children: ReactNode }) {
	const [store] = useState(() => createAttachmentStore());
	return <AttachmentStoreContext value={store}>{children}</AttachmentStoreContext>;
}
